/**
 * Folk children illustration strip — Lutfiye ambalajlarının alt kısmında
 * yer alan çocuk figürleri motifini SVG olarak tekrar ediyor.
 * Basit, çocuksu, el ele tutuşan renkli figürler.
 */
export default function KidsStrip({ className = '', darkBg = true }) {
  const skinShades = ['#F1C6A5', '#D9A57C', '#9F6A47', '#7A4A2D', '#F1C6A5'];
  const clothes = ['#B03A2E', '#D4A24C', '#3A5A3F', '#5D2A47', '#2E5C87'];
  const hats = ['#2E5C87', '#B03A2E', '#D4A24C', '#3A5A3F', '#5D2A47'];
  const line = darkBg ? '#F5EFE4' : '#0B0B0B';

  return (
    <div className={`w-full overflow-hidden select-none ${className}`}>
      <svg
        viewBox="0 0 1400 120"
        preserveAspectRatio="xMidYMid meet"
        className="w-full h-16 md:h-20"
        role="img"
        aria-label="Lutfiye folk çocuk motifi"
      >
        <line
          x1="0"
          y1="110"
          x2="1400"
          y2="110"
          stroke={line}
          strokeWidth="1.5"
        />

        {[0, 1, 2, 3, 4, 5, 6].map((i) => {
          const x = 80 + i * 200;
          const skin = skinShades[i % 5];
          const cloth = clothes[i % 5];
          const hat = hats[i % 5];
          return (
            <g key={i} transform={`translate(${x}, 0)`}>
              {/* hat */}
              <path
                d={`M -18 30 Q 0 8 18 30 Z`}
                fill={hat}
                stroke={line}
                strokeWidth="1.5"
              />
              <line
                x1="-22"
                y1="30"
                x2="22"
                y2="30"
                stroke={line}
                strokeWidth="1.5"
              />
              {/* head */}
              <circle
                cx="0"
                cy="42"
                r="14"
                fill={skin}
                stroke={line}
                strokeWidth="1.5"
              />
              {/* eyes */}
              <circle cx="-5" cy="41" r="1.5" fill={line} />
              <circle cx="5" cy="41" r="1.5" fill={line} />
              {/* smile */}
              <path
                d="M -4 47 Q 0 50 4 47"
                stroke={line}
                strokeWidth="1.2"
                fill="none"
                strokeLinecap="round"
              />
              {/* body / dress */}
              <path
                d={`M -18 62 L -22 108 L 22 108 L 18 62 Q 0 55 -18 62 Z`}
                fill={cloth}
                stroke={line}
                strokeWidth="1.5"
              />
              {/* arms — hands almost touching next kid */}
              <path
                d={`M -18 65 L -55 85`}
                stroke={line}
                strokeWidth="1.6"
                strokeLinecap="round"
                fill="none"
              />
              <path
                d={`M 18 65 L 55 85`}
                stroke={line}
                strokeWidth="1.6"
                strokeLinecap="round"
                fill="none"
              />
              {/* hands */}
              <circle cx="-55" cy="85" r="4" fill={skin} stroke={line} strokeWidth="1.2" />
              <circle cx="55" cy="85" r="4" fill={skin} stroke={line} strokeWidth="1.2" />
              {/* legs */}
              <line x1="-8" y1="108" x2="-8" y2="115" stroke={line} strokeWidth="1.5" strokeLinecap="round" />
              <line x1="8" y1="108" x2="8" y2="115" stroke={line} strokeWidth="1.5" strokeLinecap="round" />
            </g>
          );
        })}
      </svg>
    </div>
  );
}
